import { MutableRefObject, SetStateAction } from 'react';
import { Translate } from 'next-translate';

import { CustomColumnHeader, ID } from 'types';

import { isCustomColumn, getHeaderID, isVisibleToSuppliers } from './utils';

interface OnEditColumnParams {
  headerMap: ID[];
  headers?: CustomColumnHeader[];
  hotRef: MutableRefObject<any>;
  isReadOnly: boolean;
  setColumnId: (_headerId: SetStateAction<ID | undefined>) => void;
}

interface CanEditColumnParams {
  headerMap: ID[];
  headers?: CustomColumnHeader[];
  hotRef: MutableRefObject<any>;
  isReadOnly: boolean;
}

export const onEditColumn = ({
  headerMap,
  headers,
  hotRef,
  isReadOnly,
  setColumnId,
}: OnEditColumnParams): void => {
  const headerId = getHeaderID({ headerMap, hotRef });

  if (!headerId || (isReadOnly && isVisibleToSuppliers(headerId, headers))) return;
  setColumnId(headerId);
};

export const canEditColumn = ({
  headerMap,
  headers,
  hotRef,
  isReadOnly,
}: CanEditColumnParams): boolean => {
  const headerId = getHeaderID({ headerMap, hotRef });

  if (!headerId || (isReadOnly && isVisibleToSuppliers(headerId, headers))) return false;
  return isCustomColumn(headerId);
};

interface GetEditColumnNameParams {
  headerMap: ID[];
  headers?: CustomColumnHeader[];
  hotRef: MutableRefObject<any>;
  isReadOnly: boolean;
  t: Translate;
}

export const getEditColumnName = ({
  headerMap,
  headers,
  hotRef,
  isReadOnly,
  t,
}: GetEditColumnNameParams): string => {
  const headerId = getHeaderID({ headerMap, hotRef });

  if (!headerId || !isReadOnly || isVisibleToSuppliers(headerId, headers)) return t('bid_request.line_items.dropdown.edit_column');

  return t('bid_request.line_items.dropdown.edit_hidden_column');
};
